import { v4 as uuidv4 } from 'uuid'

const LOCAL_UUID = 'dupr.uuid'

export const setupDeviceId = () => {
  const uuid = uuidv4()
  localStorage.setItem(LOCAL_UUID, uuid)
  return uuid
}

export const getDeviceId = () => {
  let uuid = localStorage.getItem(LOCAL_UUID)
  if (!uuid || uuid === '') {
    uuid = setupDeviceId()
  }
  return uuid
}
